import { render, staticRenderFns } from "./printRemittance.vue?vue&type=template&id=2befac4f&scoped=true&"
import script from "./printRemittance.vue?vue&type=script&lang=js&"
export * from "./printRemittance.vue?vue&type=script&lang=js&"
import style0 from "./printRemittance.vue?vue&type=style&index=0&id=2befac4f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2befac4f",
  null
  
)

export default component.exports